/* ============================================================
   Kern Theme — JavaScript
   ============================================================ */

(function () {
  'use strict';

  var strings = window.KernStrings || {};

  /* ── Focus Trap ── */
  function trapFocus(panel, triggerEl) {
    var focusable = panel.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    );
    if (focusable.length === 0) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    panel._focusTrigger = triggerEl || document.activeElement;

    panel._focusTrapHandler = function (e) {
      if (e.key === 'Escape') {
        var drawer = panel.closest('.nav-drawer, .cart-drawer, .filter-drawer');
        if (drawer) {
          drawer.classList.remove('is-open');
          document.body.style.overflow = '';
        }
        releaseFocus(panel);
        return;
      }
      if (e.key !== 'Tab') return;
      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    panel.addEventListener('keydown', panel._focusTrapHandler);
    first.focus();
  }

  function releaseFocus(panel) {
    if (panel._focusTrapHandler) {
      panel.removeEventListener('keydown', panel._focusTrapHandler);
      delete panel._focusTrapHandler;
    }
    if (panel._focusTrigger) {
      panel._focusTrigger.focus();
      panel._focusTrigger = null;
    }
  }

  /* ── Sticky Header — hide announcement bar on scroll ── */
  var announcementBar = document.querySelector('.announcement-bar');

  if (announcementBar) {
    var announcementHeight = announcementBar.offsetHeight;
    var barHidden = false;

    window.addEventListener('scroll', function () {
      if (window.scrollY > announcementHeight && !barHidden) {
        announcementBar.style.display = 'none';
        barHidden = true;
      } else if (window.scrollY <= 5 && barHidden) {
        announcementBar.style.display = '';
        barHidden = false;
      }
    }, { passive: true });
  }

  /* ── Nav Drawer ── */
  var navDrawer = document.getElementById('nav-drawer');
  var navPanel = navDrawer ? navDrawer.querySelector('.nav-drawer__panel') : null;

  document.querySelectorAll('[data-nav-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      navDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      /* Expand all submenus on open */
      navDrawer.querySelectorAll('.nav-drawer__submenu').forEach(function (sub) {
        sub.classList.add('is-open');
      });
      navDrawer.querySelectorAll('[data-submenu-toggle]').forEach(function (toggle) {
        toggle.classList.add('is-open');
      });
      if (navPanel) trapFocus(navPanel, btn);
    });
  });

  document.querySelectorAll('[data-nav-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      navDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
      if (navPanel) releaseFocus(navPanel);
    });
  });

  /* Submenu toggles */
  document.querySelectorAll('[data-submenu-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var submenu = btn.nextElementSibling;
      if (submenu) {
        submenu.classList.toggle('is-open');
        btn.classList.toggle('is-open');
      }
    });
  });

  /* ── Cart Drawer ── */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartPanel = cartDrawer ? cartDrawer.querySelector('.cart-drawer__panel') : null;

  function openCartDrawer(triggerEl) {
    cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    refreshCart();
    if (cartPanel) trapFocus(cartPanel, triggerEl);
  }

  function closeCartDrawer() {
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
    if (cartPanel) releaseFocus(cartPanel);
  }

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openCartDrawer(btn);
    });
  });

  document.querySelectorAll('[data-cart-close]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      closeCartDrawer();
    });
  });

  /* ── Cart Toast ── */
  function showCartToast(message) {
    var toast = document.getElementById('cart-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._timeout);
    toast._timeout = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 3000);
  }

  /* ── Cart API ── */
  function refreshCart() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCartDrawer(cart); })
      .catch(function (e) { console.error('Cart fetch failed', e); });
  }

  function renderCartDrawer(cart) {
    var itemsEl = cartDrawer.querySelector('.cart-drawer__items');
    var subtotalPriceEl = cartDrawer.querySelector('.cart-drawer__subtotal-price');
    var footerEl = cartDrawer.querySelector('.cart-drawer__footer');
    var emptyEl = cartDrawer.querySelector('.cart-drawer__empty');
    var countEls = document.querySelectorAll('[data-cart-count]');

    /* Update header cart count */
    countEls.forEach(function (el) {
      el.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
    });

    /* Update potli fill + tooltip */
    var potli = document.querySelector('[data-potli]');
    if (potli) {
      var c = cart.item_count;
      potli.setAttribute('data-items', c === 0 ? '' : c === 1 ? '1' : c === 2 ? '2' : c === 3 ? '3' : 'full');
    }
    var potliTip = document.querySelector('[data-potli-tooltip]');
    if (potliTip) {
      var devNums = ['०','१','२','३','४','५','६','७','८','९'];
      function toDevNum(n) { return String(n).split('').map(function(d) { return devNums[parseInt(d)] || d; }).join(''); }
      potliTip.textContent = cart.item_count > 0 ? toDevNum(cart.item_count) + ' चीज़ें' : '';
    }

    if (cart.item_count === 0) {
      itemsEl.innerHTML = '';
      if (footerEl) footerEl.style.display = 'none';
      if (emptyEl) emptyEl.style.display = 'block';
      return;
    }

    if (footerEl) footerEl.style.display = 'block';
    if (emptyEl) emptyEl.style.display = 'none';
    if (subtotalPriceEl) subtotalPriceEl.textContent = formatMoney(cart.total_price);

    var hindiEl = cartDrawer.querySelector('[data-hindi-total]');
    if (hindiEl) {
      hindiEl.textContent = amountToHindi(cart.total_price) + ' रुपये';
      hindiEl.setAttribute('data-amount', cart.total_price);
    }


    itemsEl.innerHTML = cart.items.map(function (item) {
      var imgSrc = item.image ? getSizedImageUrl(item.image, 200) : '';
      return (
        '<div class="cart-drawer__item" data-key="' + item.key + '">' +
          '<a href="' + item.url + '" class="cart-drawer__item-image">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="cart-drawer__item-info">' +
            '<div class="cart-drawer__item-row">' +
              '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
              '<span class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</span>' +
            '</div>' +
            (item.variant_title ? '<span class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</span>' : '') +
            '<div class="cart-drawer__item-qty">' +
              '<button class="cart-drawer__qty-btn" data-change-key="' + item.key + '" data-qty="' + Math.max(0, item.quantity - 1) + '">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button class="cart-drawer__qty-btn" data-change-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '">&plus;</button>' +
            '</div>' +
            '<button class="cart-drawer__item-remove" data-remove-key="' + item.key + '">' + (strings.cartRemove || 'Remove') + '</button>' +
          '</div>' +
        '</div>'
      );
    }).join('');

    /* Bind remove buttons */
    itemsEl.querySelectorAll('[data-remove-key]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.cart-drawer__item');
        if (item) item.style.opacity = '0.4';
        btn.disabled = true;
        changeCartItem(btn.dataset.removeKey, 0);
      });
    });

    /* Bind quantity buttons */
    itemsEl.querySelectorAll('[data-change-key]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.cart-drawer__item');
        if (item) item.style.opacity = '0.4';
        btn.disabled = true;
        changeCartItem(btn.dataset.changeKey, parseInt(btn.dataset.qty, 10));
      });
    });
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed');
        return r.json();
      })
      .then(function () {
        openCartDrawer();
      })
      .catch(function () {
        showCartToast(strings.cartAddError || 'Could not add to cart. Please try again.');
      });
  }

  function changeCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
      credentials: 'same-origin',
    })
      .then(function () { return refreshCart(); })
      .catch(function () {
        showCartToast(strings.cartAddError || 'Cart update failed. Please try again.');
      });
  }

  /* ── Add to Cart forms ── */
  document.querySelectorAll('form[data-add-to-cart]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      addToCart(new FormData(form)).finally(function () {
        if (btn) btn.disabled = false;
      });
    });
  });

  /* ── Product Variants Data ── */
  var variantsEl = document.querySelector('[data-product-variants]');
  var productVariants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

  /* ── Get currently selected color ── */
  function getSelectedColor() {
    var colorInput = document.querySelector('.js-colorOption:checked');
    if (!colorInput) return null;
    return {
      value: colorInput.value,
      position: parseInt(colorInput.dataset.optionPosition, 10) - 1
    };
  }

  /* ── Update size availability based on selected color ── */
  function updateSizeAvailability() {
    var color = getSelectedColor();
    if (!color) return;

    document.querySelectorAll('.js-productOption').forEach(function (sizeInput) {
      var sizeLabel = sizeInput.dataset.label;
      /* Check if any variant exists with this color + size that is available */
      var available = false;
      var matchingVariant = null;
      for (var i = 0; i < productVariants.length; i++) {
        var v = productVariants[i];
        if (v.options[color.position] === color.value && v.options.indexOf(sizeLabel) !== -1) {
          matchingVariant = v;
          if (v.available) {
            available = true;
            break;
          }
        }
      }
      /* Update the data attribute and the variant ID */
      sizeInput.dataset.available = String(available);
      if (matchingVariant) {
        sizeInput.value = matchingVariant.id;
        sizeInput.dataset.price = formatMoney(matchingVariant.price);
      }

      /* If this size is currently selected and not available, disable add button */
      if (sizeInput.checked && !available) {
        var addBtn = document.querySelector('.product-actions__add-btn');
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.textContent = addBtn.dataset.soldOutText || 'Out of stock';
        }
      }
    });
  }

  function selectVariant(variant) {
    if (!variant) return;
    /* Update hidden or radio input for the variant ID */
    var radio = document.querySelector('.js-productOption[value="' + variant.id + '"]');
    if (radio) {
      radio.checked = true;
    } else {
      /* Try to find by label match */
      document.querySelectorAll('.js-productOption').forEach(function (r) {
        for (var i = 0; i < variant.options.length; i++) {
          if (r.dataset.label === variant.options[i]) {
            r.value = variant.id;
            r.checked = true;
          }
        }
      });
    }

    /* Also update hidden input if it exists */
    var hidden = document.querySelector('input[name="id"][type="hidden"]');
    if (hidden) hidden.value = variant.id;

    /* Update price */
    var formatted = formatMoney(variant.price);
    document.querySelectorAll('.js-pdpPrice, .js-pdpPrice-desktop').forEach(function (el) {
      el.textContent = formatted;
    });

    /* Update button */
    var addBtn = document.querySelector('.product-actions__add-btn');
    if (addBtn) {
      if (!variant.available) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.soldOutText || 'Out of stock';
      } else {
        addBtn.disabled = false;
        addBtn.textContent = addBtn.dataset.addText || 'Add to bag';
      }
    }

    /* Scroll gallery to variant's featured image */
    if (variant.featured_image && variant.featured_image.id) {
      var targetImage = document.querySelector('.product-images__item[data-image-id="' + variant.featured_image.id + '"]');
      if (targetImage) {
        if (window.innerWidth < 1024) {
          targetImage.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        } else {
          targetImage.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    }

    /* Update size availability indicators */
    updateSizeAvailability();
  }

  /* ── Color Swatch Selection ── */
  document.querySelectorAll('.js-colorOption').forEach(function (input) {
    input.addEventListener('change', function () {
      var selectedColor = input.value;
      var colorPos = parseInt(input.dataset.optionPosition, 10) - 1;

      /* Update color name text */
      var nameEl = document.querySelector('.js-colorName');
      if (nameEl) nameEl.textContent = selectedColor;

      /* Update size radios to reflect this color's availability */
      updateSizeAvailability();

      /* Get currently selected size */
      var sizeRadio = document.querySelector('.js-productOption:checked');
      var selectedSize = sizeRadio ? sizeRadio.dataset.label : null;

      /* Find variant matching this color + current size */
      var match = null;
      var fallback = null;
      for (var i = 0; i < productVariants.length; i++) {
        var v = productVariants[i];
        if (v.options[colorPos] === selectedColor) {
          if (!fallback && v.available) fallback = v;
          if (!fallback) fallback = v;
          if (selectedSize && v.options.indexOf(selectedSize) !== -1) {
            match = v;
            break;
          }
        }
      }

      selectVariant(match || fallback);
    });
  });

  /* ── Product Variant / Size Selection (radio inputs) ── */
  document.querySelectorAll('.js-productOption').forEach(function (input) {
    input.addEventListener('change', function () {
      var color = getSelectedColor();
      var sizeLabel = input.dataset.label;

      if (color) {
        /* Find variant matching selected color + this size */
        for (var i = 0; i < productVariants.length; i++) {
          var v = productVariants[i];
          if (v.options[color.position] === color.value && v.options.indexOf(sizeLabel) !== -1) {
            selectVariant(v);
            return;
          }
        }
      }

      /* Fallback: use the variant ID directly */
      var variantId = parseInt(input.value, 10);
      var variant = productVariants.find(function (v) { return v.id === variantId; });
      if (variant) selectVariant(variant);
    });
  });

  /* ── Announcement Bar Dismiss ── */
  var announcementClose = document.querySelector('[data-announcement-close]');
  if (announcementClose) {
    announcementClose.addEventListener('click', function () {
      var bar = announcementClose.closest('.announcement-bar');
      if (bar) {
        bar.style.display = 'none';
        try { sessionStorage.setItem('kern-announcement-dismissed', '1'); } catch (e) {}
      }
    });
  }

  try {
    if (sessionStorage.getItem('kern-announcement-dismissed') === '1') {
      var bar = document.querySelector('.announcement-bar');
      if (bar) bar.style.display = 'none';
    }
  } catch (e) {}

  /* ── Gallery Dots ── */
  var gallery = document.querySelector('[data-gallery]');
  var dots = document.querySelectorAll('[data-dot]');

  if (gallery && dots.length > 0) {
    var items = gallery.querySelectorAll('.product-images__item');

    /* Click dot to scroll to image */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.dot, 10);
        if (items[index]) {
          if (window.innerWidth < 1024) {
            items[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          } else {
            items[index].scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      });
    });

    /* Update active dot on scroll */
    var dotObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var index = entry.target.dataset.index;
          dots.forEach(function (d) { d.classList.remove('is-active'); });
          document.querySelectorAll('[data-dot="' + index + '"]').forEach(function (d) {
            d.classList.add('is-active');
          });
        }
      });
    }, { root: window.innerWidth < 1024 ? gallery : null, threshold: 0.5 });

    items.forEach(function (item) {
      dotObserver.observe(item);
    });
  }

  /* ── Filter Drawer ── */
  var filterDrawer = document.getElementById('filter-drawer');
  if (filterDrawer) {
    var filterPanel = filterDrawer.querySelector('.filter-drawer__panel');

    document.querySelectorAll('[data-filter-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterDrawer.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (filterPanel) trapFocus(filterPanel, btn);
      });
    });

    document.querySelectorAll('[data-filter-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        filterDrawer.classList.remove('is-open');
        document.body.style.overflow = '';
        if (filterPanel) releaseFocus(filterPanel);
      });
    });

    /* Filter form submit */
    var filterForm = document.querySelector('[data-filter-form]');
    if (filterForm) {
      filterForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var params = new URLSearchParams();
        filterForm.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
          params.append(input.name, input.value);
        });
        filterForm.querySelectorAll('input[type="number"]').forEach(function (input) {
          if (input.value) params.append(input.name, input.value);
        });
        var sortSelect = document.querySelector('[data-sort-select]');
        if (sortSelect && sortSelect.value) params.append('sort_by', sortSelect.value);
        window.location.search = params.toString();
      });
    }
  }

  /* Sort select */
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ── Accordions ── */
  var allTriggers = document.querySelectorAll('[data-accordion-trigger]');
  allTriggers.forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var content = trigger.nextElementSibling;
      var isOpen = content.classList.contains('is-open');

      // Close all others
      allTriggers.forEach(function (other) {
        other.nextElementSibling.classList.remove('is-open');
        other.setAttribute('aria-expanded', 'false');
      });

      // Toggle clicked one
      if (!isOpen) {
        content.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Helpers ── */
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100).toString();
    var amountWithComma = amount.replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    var amountNoDecimalsWithComma = amountNoDecimals.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    var format = window.Shopify && window.Shopify.moneyFormat ? window.Shopify.moneyFormat : '${{amount}}';
    return format
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimalsWithComma)
      .replace('{{amount_with_apostrophe_separator}}', amount.replace(/(\d)(?=(\d{3})+\.)/g, "$1'"))
      .replace('{{amount}}', amountWithComma)
      .replace('{{amount_no_decimals}}', amountNoDecimalsWithComma);
  }

  function getSizedImageUrl(url, width) {
    if (!url) return '';
    /* Modern Shopify CDN: use width query parameter */
    if (url.indexOf('cdn.shopify.com') !== -1) {
      try {
        var u = new URL(url);
        u.searchParams.set('width', String(width));
        return u.toString();
      } catch (e) {
        /* fallback: append width param */
        return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
      }
    }
    /* Legacy: insert size suffix before extension */
    var m = url.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?.*)?$/i);
    if (m) {
      var prefix = url.split(m[0]);
      return prefix[0] + '_' + width + 'x.' + m[1] + (m[2] || '');
    }
    return url;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ── Back to Top ── */
  var backToTop = document.getElementById('back-to-top');
  if (backToTop) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 600) {
        backToTop.classList.add('is-visible');
      } else {
        backToTop.classList.remove('is-visible');
      }
    }, { passive: true });

    backToTop.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ── Size Guide Modal ── */
  var sizeGuideModal = document.getElementById('size-guide-modal');
  if (sizeGuideModal) {
    var sgPanel = sizeGuideModal.querySelector('.size-guide-modal__panel');

    document.querySelectorAll('[data-size-guide-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        sizeGuideModal.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (sgPanel) trapFocus(sgPanel, btn);
      });
    });

    document.querySelectorAll('[data-size-guide-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeGuideModal.classList.remove('is-open');
        document.body.style.overflow = '';
        if (sgPanel) releaseFocus(sgPanel);
      });
    });
  }

  /* ── Carousel ── */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-carousel-track]');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    if (!track) return;

    function getScrollAmount() {
      var slide = track.querySelector('.featured-collection__carousel-slide');
      return slide ? slide.offsetWidth : 300;
    }

    function updateArrows() {
      var scrollLeft = Math.round(track.scrollLeft);
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.style.display = scrollLeft <= 1 ? 'none' : 'flex';
      if (nextBtn) nextBtn.style.display = scrollLeft >= maxScroll - 1 ? 'none' : 'flex';
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });
    }
  });

  /* ── Load More ── */
  var loadMoreBtn = document.querySelector('[data-load-more]');
  if (loadMoreBtn) {
    loadMoreBtn.addEventListener('click', function () {
      var nextUrl = loadMoreBtn.dataset.nextUrl;
      if (!nextUrl) return;

      loadMoreBtn.disabled = true;
      var originalText = loadMoreBtn.textContent;
      loadMoreBtn.textContent = '...';

      fetch(nextUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('.collection-grid .product-card');
          var grid = document.querySelector('.collection-grid');

          newCards.forEach(function (card) {
            grid.appendChild(document.adoptNode(card));
          });

          var newBtn = doc.querySelector('[data-load-more]');
          if (newBtn && newBtn.dataset.nextUrl) {
            loadMoreBtn.dataset.nextUrl = newBtn.dataset.nextUrl;
            loadMoreBtn.disabled = false;
            loadMoreBtn.textContent = originalText;
          } else {
            loadMoreBtn.closest('.load-more').style.display = 'none';
          }
        })
        .catch(function () {
          loadMoreBtn.disabled = false;
          loadMoreBtn.textContent = originalText;
        });
    });
  }

  /* ── Hindi number-to-words (Indian numbering system) ──
     To remove: delete this block */
  function amountToHindi(paise) {
    var n = Math.floor(paise / 100);
    if (n === 0) return 'शून्य';

    var ones = ['', 'एक', 'दो', 'तीन', 'चार', 'पाँच', 'छह', 'सात', 'आठ', 'नौ',
      'दस', 'ग्यारह', 'बारह', 'तेरह', 'चौदह', 'पंद्रह', 'सोलह', 'सत्रह', 'अठारह', 'उन्नीस',
      'बीस', 'इक्कीस', 'बाईस', 'तेईस', 'चौबीस', 'पच्चीस', 'छब्बीस', 'सत्ताईस', 'अट्ठाईस', 'उनतीस',
      'तीस', 'इकतीस', 'बत्तीस', 'तैंतीस', 'चौंतीस', 'पैंतीस', 'छत्तीस', 'सैंतीस', 'अड़तीस', 'उनतालीस',
      'चालीस', 'इकतालीस', 'बयालीस', 'तैंतालीस', 'चवालीस', 'पैंतालीस', 'छियालीस', 'सैंतालीस', 'अड़तालीस', 'उनचास',
      'पचास', 'इक्यावन', 'बावन', 'तिरपन', 'चौवन', 'पचपन', 'छप्पन', 'सत्तावन', 'अट्ठावन', 'उनसठ',
      'साठ', 'इकसठ', 'बासठ', 'तिरसठ', 'चौंसठ', 'पैंसठ', 'छियासठ', 'सड़सठ', 'अड़सठ', 'उनहत्तर',
      'सत्तर', 'इकहत्तर', 'बहत्तर', 'तिहत्तर', 'चौहत्तर', 'पचहत्तर', 'छिहत्तर', 'सतहत्तर', 'अठहत्तर', 'उनासी',
      'अस्सी', 'इक्यासी', 'बयासी', 'तिरासी', 'चौरासी', 'पचासी', 'छियासी', 'सतासी', 'अट्ठासी', 'नवासी',
      'नब्बे', 'इक्यानवे', 'बानवे', 'तिरानवे', 'चौरानवे', 'पचानवे', 'छियानवे', 'सत्तानवे', 'अट्ठानवे', 'निन्यानवे'];

    var parts = [];
    if (n >= 10000000) { parts.push(ones[Math.floor(n / 10000000)] + ' करोड़'); n = n % 10000000; }
    if (n >= 100000) { parts.push(ones[Math.floor(n / 100000)] + ' लाख'); n = n % 100000; }
    if (n >= 1000) { parts.push(ones[Math.floor(n / 1000)] + ' हज़ार'); n = n % 1000; }
    if (n >= 100) { parts.push(ones[Math.floor(n / 100)] + ' सौ'); n = n % 100; }
    if (n > 0) { parts.push(ones[n]); }
    return parts.join(' ');
  }

  // Render Hindi total on page load
  var hindiTotalEl = document.querySelector('[data-hindi-total]');
  if (hindiTotalEl) {
    var amt = parseInt(hindiTotalEl.getAttribute('data-amount'), 10);
    if (amt > 0) hindiTotalEl.textContent = amountToHindi(amt) + ' रुपये';
  }

  /* ── Public API ── */
  window.Kern = {
    openCartDrawer: openCartDrawer,
    closeCartDrawer: closeCartDrawer,
    refreshCart: refreshCart,
    addToCart: addToCart,
  };

  /* ── Size memory — remembers your size ──
     To remove: delete this block */
  var sizeInputs = document.querySelectorAll('.pdp-buy__option:not(.pdp-buy__color) input[type="radio"]');
  if (sizeInputs.length > 0) {
    var savedSize = localStorage.getItem('kern-size');

    // Pre-select saved size
    if (savedSize) {
      var matched = false;
      sizeInputs.forEach(function (input) {
        var label = input.nextElementSibling;
        if (label && label.textContent.trim() === savedSize && input.dataset.available !== 'false') {
          input.checked = true;
          matched = true;
        }
      });

      // Show "pichli baar" hint
      if (matched) {
        var legend = document.querySelector('.pdp-buy__option:not(.pdp-buy__color) .pdp-buy__legend');
        if (legend) {
          var hint = document.createElement('span');
          hint.className = 'size-memory-hint';
          hint.textContent = savedSize + ' liya tha na?';
          legend.appendChild(hint);
          setTimeout(function () { hint.style.opacity = '0'; }, 3000);
        }
      }
    }

    // Save size on selection
    sizeInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        var label = this.nextElementSibling;
        if (label) localStorage.setItem('kern-size', label.textContent.trim());
      });
    });
  }

  /* ── Bazaar haggle price animation ──
     To remove: delete this block + remove 'haggle-price' class and data attrs from product.liquid */
  document.querySelectorAll('.haggle-price').forEach(function (el) {
    var from = parseInt(el.getAttribute('data-from'), 10) / 100;
    var to = parseInt(el.getAttribute('data-to'), 10) / 100;
    if (!from || !to || from <= to) return;

    var duration = 1200;
    var start = null;
    var format = window.Shopify && window.Shopify.moneyFormat || 'Rs. {{amount}}';

    function formatPrice(val) {
      return format.replace('{{amount}}', val.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
    }

    el.textContent = formatPrice(from);
    setTimeout(function () {
      requestAnimationFrame(function step(ts) {
        if (!start) start = ts;
        var progress = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = from - (from - to) * eased;
        el.textContent = formatPrice(Math.round(current));
        if (progress < 1) requestAnimationFrame(step);
        else el.textContent = formatPrice(to);
      });
    }, 500);
  });

  /* ── Custom cursor dot on product cards ──
     To remove: delete this block */
  var dot = document.createElement('div');
  dot.className = 'product-card__dot';
  document.body.appendChild(dot);

  document.addEventListener('mousemove', function (e) {
    dot.style.left = e.clientX + 'px';
    dot.style.top = e.clientY + 'px';
  });

  var dotTargets = '.product-card, .product-images__item, .pdp-buy__option label';

  document.addEventListener('mouseover', function (e) {
    if (e.target.closest('.pdp-buy__color')) return;
    if (e.target.closest(dotTargets)) {
      dot.classList.add('product-card__dot--visible');
    }
  });

  document.addEventListener('mouseout', function (e) {
    if (e.target.closest('.pdp-buy__color')) {
      dot.classList.remove('product-card__dot--visible');
      return;
    }
    var from = e.target.closest(dotTargets);
    var to = e.relatedTarget?.closest(dotTargets);
    if (from && !to) {
      dot.classList.remove('product-card__dot--visible');
    }
  });
})();
